import {all, fork} from 'redux-saga/effects';
import adminsSaga from './adminsSaga';
import buildingsSaga from './buildingsSaga';
import cardsSaga from './cardsSaga';
import customersSaga from './customersSaga';
import elevatorsSaga from './elevatorsSaga';
import entrancesSaga from './entrancesSaga';
import garagesSaga from './garagesSaga';
import modalSaga from './modalSaga';
import paymentsSaga from './paymentsSaga';
import pdfReportsSaga from './pdfReportsSaga';
import reportsSaga from './reportsSaga';
import userSaga from './userSaga';
import supervisorsSaga from './supervisorsSaga';

export default function* rootSaga() {
  yield all([
    fork(adminsSaga),
    fork(supervisorsSaga),
    fork(buildingsSaga),
    fork(cardsSaga),
    fork(customersSaga),
    fork(elevatorsSaga),
    fork(entrancesSaga),
    fork(garagesSaga),
    fork(modalSaga),
    fork(paymentsSaga),
    fork(pdfReportsSaga),
    fork(reportsSaga),
    fork(userSaga),
  ]);
}
